import { APIService } from '@services/api/common-services';
import { UseMutateFunction, useMutation } from '@tanstack/react-query';
import { ISiteLead } from '.';
import useSiteLeadStore from '@store/siteLeadStore';
import { APICONFIG } from '@config/api.config';

interface IUpdateKAESSNewLeadData {
	mutate: UseMutateFunction<ISiteLead, Error, ISiteLead, unknown>;
	error: Error | null;
	isError: boolean;
	isPending: boolean;
}

export const useUpdateKAESSNewLead = (): IUpdateKAESSNewLeadData => {
	const { siteId } = useSiteLeadStore();

	const updateKAESSNewLead = async (siteLeadFormData: ISiteLead): Promise<ISiteLead> => {
		const url = `${APICONFIG.UPDATE_SITE_LEAD}${siteId}/update_site_lead/`;
		return await APIService.patchData<ISiteLead>(url, siteLeadFormData);
	};

	const { mutate, error, isError, isPending } = useMutation({
		mutationFn: updateKAESSNewLead,
	});

	return {
		mutate,
		error,
		isError,
		isPending,
	};
};
